__turbopack_context__.v({
  "className": "inter_1ccfef08-module__TBkFXG__className",
});
